import {
  MapPin,
  Phone,
  Mail,
  Clock,
  ArrowRight,
} from "lucide-react";

import demo from "../assests/heropage.png";

const ContactSection = () => {
  return (
    <section className="bg-[#FAF7F3] text-[#1F1B18]">

      {/* Hero */}

      <div className="relative h-[60vh] overflow-hidden">

        <img
          src={demo}
          alt=""
          className="absolute inset-0 w-full h-full object-cover brightness-75"
        />

        <div className="absolute inset-0 bg-black/30" />

        <div className="relative z-10 h-full flex items-center justify-center">

          <div className="text-center text-white px-6">

            <p className="uppercase tracking-[4px] text-sm mb-5">
              Contact Us
            </p>

            <h1 className="font-heading text-6xl">
              We'd Love To
              <br />
              Hear From You
            </h1>

            <p className="mt-6 max-w-xl mx-auto leading-8 text-white/90">

              Whether you have a question about skincare,
              your order or simply want to say hello —
              our team is always here to help.

            </p>

          </div>

        </div>

      </div>

      {/* Contact Section */}

      <div className="max-w-7xl mx-auto py-28 px-6 grid lg:grid-cols-2 gap-20">

        {/* Left */}

        <div>

          <span className="uppercase tracking-[4px] text-[#B68B4C]">

            Get In Touch

          </span>

          <h2 className="font-heading text-5xl mt-5 mb-12">

            Let's Start
            A Conversation

          </h2>

          <div className="space-y-8">

            <div className="flex gap-5">

              <div className="w-14 h-14 rounded-full bg-white flex items-center justify-center shadow">

                <MapPin size={22} />

              </div>

              <div>

                <h3 className="font-semibold">
                  Visit Us
                </h3>

                <p className="text-gray-600 mt-2">
                  New Delhi, India
                </p>

              </div>

            </div>

            <div className="flex gap-5">

              <div className="w-14 h-14 rounded-full bg-white flex items-center justify-center shadow">

                <Phone size={22} />

              </div>

              <div>

                <h3 className="font-semibold">
                  Call Us
                </h3>

                <p className="text-gray-600 mt-2">
                  +91 98765 43210
                </p>

              </div>

            </div>
            <div className="flex gap-5">
              <div className="w-14 h-14 rounded-full bg-white flex items-center justify-center shadow">
                <Mail size={22} />
              </div>
              <div>
                <h3 className="font-semibold">
                  Email
                </h3>
                <p className="text-gray-600 mt-2">
                  hello@celiora.com
                </p>
              </div>
            </div>
            <div className="flex gap-5">
              <div className="w-14 h-14 rounded-full bg-white flex items-center justify-center shadow">

                <Clock size={22} />
              </div>
              <div>
                <h3 className="font-semibold">
                  Working Hours
                </h3>
                <p className="text-gray-600 mt-2">
                  Mon - Sat
                  <br />
                  10:00 AM - 7:00 PM
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Form */}

        <div className="bg-white rounded-3xl p-10 shadow-xl">
          <h2 className="font-heading text-4xl mb-8">
            Send Message
          </h2>
          <form className="space-y-6">
            <input
              type="text"
              placeholder="Full Name"
              className="w-full border border-[#E6DED2] rounded-xl px-5 py-4 outline-none focus:border-[#B68B4C]"
            />
            <input
              type="email"
              placeholder="Email Address"
              className="w-full border border-[#E6DED2] rounded-xl px-5 py-4 outline-none focus:border-[#B68B4C]"
            />
            <input
              type="tel"
              placeholder="Phone Number"
              className="w-full border border-[#E6DED2] rounded-xl px-5 py-4 outline-none focus:border-[#B68B4C]"
            />
            <input
              type="text"
              placeholder="Subject"
              className="w-full border border-[#E6DED2] rounded-xl px-5 py-4 outline-none focus:border-[#B68B4C]"
            />
            <textarea
              rows={6}
              placeholder="Your Message"
              className="w-full border border-[#E6DED2] rounded-xl px-5 py-4 outline-none resize-none focus:border-[#B68B4C]"
            />
            <button
              className="w-full bg-[#1F1B18] text-white rounded-full py-4 flex items-center justify-center gap-3 hover:bg-[#B68B4C] duration-300"
            >
              Send Message
              <ArrowRight size={18} />
            </button>
          </form>
        </div>
      </div>

      {/* Studio */}

      <div className="max-w-7xl mx-auto px-6 pb-28">
        <div className="rounded-[40px] overflow-hidden relative">
          <img
            src={demo}
            alt=""
            className="w-full h-[520px] object-cover"
          />
          <div className="absolute inset-0 bg-black/30" />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center text-white">
              <p className="uppercase tracking-[4px] mb-4">
                Visit Our Studio
              </p>
              <h2 className="font-heading text-5xl">
                Experience
                <br />
                Celiora In Person
              </h2>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};

export default ContactSection;